/**
 * Campaign-detail polling windows.
 */

/** How long a `pending` job is polled before we stop waiting. */
export const POLL_WINDOW_MS = 2 * 60_000;

/** Audience dynamics acquires from Apify inside the job (median 186s, p90 661s),
 *  so it needs a longer window than the lanes that return at once. */
export const AUDIENCE_POLL_WINDOW_MS = 12 * 60_000;
export const AUDIENCE_POLL_FAST_MS = 5_000;
export const AUDIENCE_POLL_FAST_UNTIL_MS = 60_000;
export const AUDIENCE_POLL_SLOW_MS = 15_000;
